// extracted by mini-css-extract-plugin
export var dropdown = "_sm-0";
export var imageWrapper = "_sm-3";
export var itemNameContainer = "_sm-1";
export var productImage = "_sm-2";
export var spinnerWrapper = "_sm-4";